import styles from "./index.module.css";
const Loading = ({ loadProgress }) => {
  return (
    <div
      className={`${styles.ctn} ${loadProgress === 100 ? styles.loaded : ""}`}
      style={{
        '--effect-progress':loadProgress / 100
      }}
    >
      <div className={styles.progressText}>{loadProgress}%</div>

      <svg
        width="291"
        height="124"
        viewBox="0 0 291 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.loadingSvg}
      >
        <rect
          x="2"
          y="2"
          width="287"
          height="120"
          stroke="white"
          stroke-opacity="0.2"
          stroke-width="4"
        />

        <rect
          x="2"
          y="2"
          width="287"
          height="120"
          stroke="white"
          stroke-width="4"
          className={styles.progressPath}
        />
      </svg>
    </div>
  );
};

export default Loading;
